/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Queue_Shipments_WaitingInputs */

const en_queue_shipments_waiting = /** @type {(inputs: Queue_Shipments_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warehouse shipments to apply`)
};

/**
* | output |
* | --- |
* | "Warehouse shipments to apply" |
*
* @param {Queue_Shipments_WaitingInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const queue_shipments_waiting = /** @type {((inputs?: Queue_Shipments_WaitingInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Queue_Shipments_WaitingInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_queue_shipments_waiting(inputs)
});